/**
 * store/modules/admin/adminConsignor.js
 *
 * Vuex module handling admin-consignor state and actions.
 */
import axios from 'axios'

export default {
  // admin consignor state.
  state: {
    adminConsignorList: [],
    adminConsignor: {}
  },

  // Mutations to alter admin consignor state.
  mutations: {
    setConsignorList: (state, consignorList) => (state.adminConsignorList = consignorList),
    setConsignor: (state, consignor) => (state.adminConsignor= consignor)
  },

  // Actions handling requests, and committing mutations.
  actions: {
    // Grab the consignor list.
    async getConsignors ({ commit }) {
      try {
        let response = await axios.get('/api/consignor')
        // Consignor list fetch success, set to state.
        commit('setConsignorList', response.data)
      }
      catch {
        // Consignor list fetch failed.
        console.error('Unable to fetch consignors.')
      }
    },

    // Grab the consignor by Id.
    async getConsignorById ({ commit }, consignorId) {
      try {
        let response = await axios.get(`/api/consignor/${consignorId}`)
        // Consignor fetch success, set to state.
        commit('setConsignor', response.data)
      }
      catch {
        // Consignor fetch failed.
        console.error('Unable to fetch consignor.')
      }
    },

    /**
     * Ceate a consignor.
     *
     * consignor: {
     *   description: "string",
     *   imageUrl: "string",
     *   name: "string"
     * }
     */
    async createConsignor ({ commit, dispatch }, consignor) {
      try {
        let response = await axios.post('/api/admin/consignor', consignor)
        // Consignor creted, set it and refresh the list.
        commit('setConsignor', response.data)
        dispatch('getConsignors')
      }
      catch (err) {
        // Asset list fetch failed.
        console.error('Unable to create consignor.')
        throw(err)
      }
    },

    // Set a consignor to state by ID.
    setConsignorById ({ state, commit }, consignorId) {
      // There is currently no endpoint to fetch by id
      // so we're finding it in the list.
      let foundConsignor = {}
      Object.assign(foundConsignor, state.adminConsignorList.find(consignor => consignor.id === consignorId))

      commit('setConsignor', foundConsignor)
    },

    // Clear the consignor from state.
    clearConsignor ({ commit }) {
      console.log('clearing')
      commit('setConsignor', {})
    },

    // Attach an image to the given consignor.
    async updateConsignorImage ({ commit, dispatch }, { consignorId, file }) {
      // Arrange the file as form data.
      let fileFormData = new FormData()
      fileFormData.append('file', file)

      try {
        let response = await axios.put(`/api/admin/consignor/${consignorId}/image`, fileFormData, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        })

        commit('setConsignor', response.data)
        dispatch('getConsignors')
      }
      catch (err) {
        console.error('Unable to attach image.')
        throw(err)
      }
    },

    /**
     * Update a consignor.
     *
     * consignor: {
     *   id: consignorId to update
     *   description: "string",
     *   imageUrl: "string",
     *   name: "string",
     *   managerId: user id of manager
     * }
     */
    async updateConsignor ({ commit, dispatch }, consignor) {
      // Peel off id from payload.
      const consigId = consignor.id
      delete consignor.id

      try {
        let response = await axios.put(`/api/admin/consignor/${consigId}`, consignor)
        // Consignor updated, set it and refresh the list.
        commit('setConsignor', response.data)
        dispatch('getConsignors')
      }
      catch (err) {
        // Consignor update failed.
        console.error(`Unable to update consignor ${consignor.id}.`)
        throw(err)
      }
    },
  },

  // User state getters.
  getters: {
    adminConsignorList: state => state.adminConsignorList,
    adminConsignor: state => state.adminConsignor
  }
}
